import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";

import { toast } from "react-toastify";
import Pagination from "../../../../components/Pagination";
import { Modal as AntModal, Spin } from "antd";
import Modal from "react-modal";
import moment from "moment";

const DpiListview = (props) => {
  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));

  const [deleteLoading, setDeleteLoading] = useState(false);

  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "700px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    //console.log(data);
    setSelectedData(data);

    setIsModalOpen(true);
  };
  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [dpiData, setDpiData] = useState([]);
  const [allData, setAllData] = useState([]);

  const { sendRequest: getDuringPackhouseInspection } = useHttp();

  const getData = () => {
    getDuringPackhouseInspection(
      {
        url: "/api/duringPackhouseInspection/",
      },
      (res) => {
        if (res) {
          //console.log(res);
          const sortedData = res.sort((a, b) => b.dpiId - a.dpiId);

          setData(sortedData);
          setDpiData(res[0]);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.activityDoc.includes(filetrtext) ||
        item.dpInspectionNo.includes(filetrtext) ||
        item.employeeName.includes(filetrtext) ||
        item.lotNo.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };
  const { sendRequest: dpiDelete } = useHttp();

  const handleDelete = (e, dpiId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content:
        "Are you sure you want to delete this During Packhouse Inspection detail?",
      onOk() {
        setDeleteLoading(dpiId);
        const data = {
          dpiId: dpiId,
          serviceId: serviceId,
        };
        //console.log(data);

        dpiDelete(
          {
            url: "/api/duringPackhouseInspection/",
            method: "DELETE",
            body: data,
          },
          (data) => {
            toast.success(data);
            getData();
            setDeleteLoading(false);
          },
          () => {
            toast.success("Data Deleted Successfully");
            getData();
            setDeleteLoading(false);
          }
        );
      },
      onCancel() {
        setDeleteLoading(false);
      },
    });
  };

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">
              During Packhouse Inspection
            </label>
          </div>

          <div className="col-6 text-right">
            {canAdd === "block" && (
              <button
                type="button"
                className="btn  btn-primary mx-3 my-3"
                onClick={() => {
                  addForm(true);
                  sId(serviceId);
                  props.update(false);
                }}
              >
                Add Packhouse Inspection
              </button>
            )}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4">
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>DPI Date</th>
                          <th>InspectionTime</th>
                          <th>Activity Doc</th>
                          <th>Doc No</th>
                          <th>Lot No</th>
                          <th>Assigned Supervisor</th>

                          <th>Temp(°C)</th>
                          <th>Deficiences</th>

                          {canEdit === "block" && <th>Edit</th>}
                          {canDelete === "block" && <th>Delete</th>}
                          {canView === "block" && <th>View</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.dpiDate}</td>
                                <td>
                                  {moment(
                                    itm.inspectionTime,
                                    "HH:mm:ss"
                                  ).format("hh:mm A")}
                                </td>
                                <td>{itm.activityDoc}</td>
                                <td>{itm.dpInspectionNo}</td>
                                <td>{itm.lotNo}</td>
                                <td>{itm.employeeName}</td>

                                <td>{itm.temperature}</td>
                                <td>{itm.deficiencies}</td>

                                {canEdit === "block" && (
                                  <td>
                                    <button
                                      onClick={() => {
                                        props.addForm(true);
                                        props.update(itm);
                                      }}
                                      className="btn"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                  </td>
                                )}
                                {canDelete === "block" && (
                                  <td>
                                    {deleteLoading === itm.dpiId ? (
                                      <Spin />
                                    ) : (
                                      <button
                                        onClick={(e) =>
                                          handleDelete(e, itm.dpiId)
                                        }
                                        className="btn"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </button>
                                    )}
                                  </td>
                                )}
                                {canView === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() => openModal(itm)}
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title">During Packhouse Inspection Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                During Packhouse Inspection No:{" "}
                {selectedData.arrivalQualityCheckNo}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                During Packhouse Inspection Date: {selectedData.aqcDate}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Assign Supervisor: {selectedData.employeeName}
              </p>
              <p className="col-md-6">Inspection Time : {selectedData.email}</p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Stage of Packhouse: {selectedData.avgUnitWeight}
              </p>
              <p className="col-md-6">Lot No: {selectedData.unit}</p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Temperature (°C) : {selectedData.temperature}
              </p>

              <p className="col-md-6">
                Deficiencies: {selectedData.deficiencies}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Shelf Life Days : {selectedData.shelfLifeDays}
              </p>
            </div>
            <br />
            <h5 className="card-title">Product Details</h5>
            <table className="table table-bordered table-sm">
              <thead>
                <tr className="">
                  <th>Item Id</th>
                  <th>Item Description</th>
                  <th>Item Type</th>
                  <th>Item Category/Variety</th>
                  <th>Item Quantity</th>
                  <th>Unit</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.productDetails &&
                  selectedData.productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.itemId}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.productTypeName}</td>
                        <td>{itm.productSubTypeName}</td>
                        <td>{itm.productQuantityBal}</td>
                        <td>{itm.unitName}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <h5 className="card-title">Freshness Details</h5>
            <table className="table tabel-sm text-center table-bordered">
              <thead>
                <tr>
                  <th>Average Unit Size</th>
                  <th>Unit</th>
                  <th>Shape</th>
                  <th>Colour</th>
                  <th>Flesh Firmness</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{selectedData.freshness.avgUnitSize}</td>
                  <td>{selectedData.freshness.unit}</td>
                  <td>{selectedData.freshness.shape}</td>
                  <td>{selectedData.freshness.colour}</td>
                  <td>{selectedData.freshness.fleshFirmness}</td>
                </tr>
              </tbody>
            </table>{" "}
            {/**/}
          </div>
        )}
        <h5 className="card-title">Check List Details</h5>
        <br />
        <div className="row">
          <p className="col-md-6" style={{ textAlign: "left" }}>
            Contamination: {selectedData && selectedData.co}
          </p>
          <p className="col-md-6" style={{ textAlign: "left" }}>
            Standard Packaging Material: {selectedData && selectedData.aqcDate}
          </p>
        </div>
        <div className="row">
          <p className="col-md-6" style={{ textAlign: "left" }}>
            Durable Material:{" "}
            {selectedData && selectedData.arrivalQualityCheckNo}
          </p>
          <p className="col-md-6" style={{ textAlign: "left" }}>
            Proper Cushioning/Padding: {selectedData && selectedData.aqcDate}
          </p>
        </div>
        <div className="row">
          <p className="col-md-6" style={{ textAlign: "left" }}>
            Sealed Effectivly:{" "}
            {selectedData && selectedData.arrivalQualityCheckNo}
          </p>
          <p className="col-md-6" style={{ textAlign: "left" }}>
            Cleaning Detergent Precise: {selectedData && selectedData.aqcDate}
          </p>
        </div>
        <div className="row">
          <p className="col-md-6" style={{ textAlign: "left" }}>
            Fungicide Percent:{" "}
            {selectedData && selectedData.arrivalQualityCheckNo}
          </p>
          <p className="col-md-6" style={{ textAlign: "left" }}>
            Sorting According to defined size:{" "}
            {selectedData && selectedData.aqcDate}
          </p>
        </div>
        <div className="row">
          <p className="col-md-6" style={{ textAlign: "left" }}>
            Disposal correctly:{" "}
            {selectedData && selectedData.arrivalQualityCheckNo}
          </p>
          <p className="col-md-6" style={{ textAlign: "left" }}>
            Grading as per Standard: {selectedData && selectedData.aqcDate}
          </p>
        </div>
      </Modal>
    </>
  );
};

export default DpiListview;
